export default __webpack_public_path__ + "static/pc-price-747c4e6111412afcfabaaf9f7aa3035b.svg";